import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { IWorkspaceListActivitiesResponse } from "./types";

import { ListActivities } from "./ListActivities";
import { Adesao } from "../Activity/Adesao";
import { Page } from "v2/components";

import api from "services/api";
import { useState } from "react";
import { useAuth } from "contexts/auth";

/**
 * GET /workspaces/:workspaceId/activities
 * @returns
 * {
 *  workspace: {}, Necessary data for navigation
 *  activities: []
 * }
 */
export function WorkspaceListActivities() {
  const { workspaceId } = useParams() as { workspaceId: string };
  const user = useAuth();
  const isSeller = user.user?.isSeller;
  // const workspaceId = "d2968191-9eca-4832-a686-47c1079783e3";

  const [view, setView] = useState<null | "movimentacao" | "adesao">(null);

  const { data, isFetching, isFetched, isError } = useQuery({
    queryKey: ["activities", workspaceId],
    queryFn: () => api.get<{ data: IWorkspaceListActivitiesResponse }>(`/v2/workspaces/${workspaceId}/templates`),
    select: (data) => ({
      workspace: data?.data?.data?.workspace,
      activities: {
        activitiesLoad: data?.data?.data?.activities?.filter(
          (template) => template.category === "LOAD"
        ),
        activitiesProcess: data?.data?.data?.activities?.filter(
          (template) => template.category === "EXECUTE"
        ),
        activitiesValidation: data?.data?.data?.activities?.filter(
          (template) => template.category === "CHECK"
        ),
        activitiesSimulation: data?.data?.data?.activities?.filter(
          (template) => template.category === "SIMULATE"
        ),
      },
    }),
  });

  return (
    <>
      {!isFetched && isFetching && <div>Loading...</div>}
      {!isFetched && isError && <div>Error...</div>}
      {data && (
        <Page
          title={data.workspace.productName}
          ///v2/workspaces/:buyerId/:sellerId
          backRoute={`/v2/organizations/${isSeller ? data.workspace.buyerId : data.workspace.sellerId}/workspaces`}
          // backRoute={`/v2/workspaces/${data.workspace.buyerId}/${data.workspace.sellerId}`}
          // backRoute={`/v2/workspaces?sellerId=${data.workspace.sellerId}&buyerId=${data.workspace.buyerId}`}
        >
          <Page.Tab name="Atividades">
            <>
              {!view && <ListActivities activities={data.activities} workspace={data.workspace} /> }
              {view === "adesao" && <Adesao />}
            </>
          </Page.Tab>
          <Page.Tab name="Histórico" disabled />
          <Page.Tab name="Contrato" disabled />
        </Page>
      )}
    </>
  );
}
